import { View } from 'react-native'
import { styled } from '~/core/styled'

export const BenefitsPriceContainer = styled(View, theme => {
  return {
    base: {
      marginTop: 'auto',
      gap: theme.spacingStackOnepulse,
    },
  }
})
